import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { i18n } from './plugins/i18n'
import FlagIcon from 'vue-flag-icon'
import axios from 'axios'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.prototype.$http = axios

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// axios.defaults.baseURL = " http://localhost:8000/";
axios.defaults.baseURL = 'https://apievisaevisacameroun2.webcoom.net/'
axios.defaults.withCredentials = true

axios.interceptors.response.use(
    function(response) {
        store.commit('SET_GLOBAL_ERROR', false)
        return response
    },
    function(error) {
        if (
            error.message === 'Network Error' ||
            (error.response && error.response.status >= 500)
        ) {
            store.commit('SET_GLOBAL_ERROR', true)
        }
        return Promise.reject(error)
    },
)

Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(FlagIcon)
Vue.use(VueAwesomeSwiper /* { default options with global component } */ )
Vue.use(VueViewer)
new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')